import { useEffect, useState } from "@wordpress/element";
import { useNavigate } from "react-router-dom";
import Paper from "@mui/material/Paper";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import { FormProvider, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { yupResolver } from "@hookform/resolvers/yup";
import { Button } from "vino/core";
import {
	fetchPaymentMethods,
	selectPaymentMethods,
} from "store/vino/paymentMethodsSlice";
import { updatePaymentMethod } from "store/vino/checkoutSlice";
import PaymentMethodCard from "../../PaymentMethodCard";
import BillingAddress from "../../BillingAddress";
import { PaymentSchema, paymentDefaultValues } from "../../models";
import PaymentList from "./PaymentList";

const PaymentMethodOptions = ({ onBack }) => {
	const navigate = useNavigate();
	const [useShippingAddress, setUseShippingAddress] = useState(true);
	const dispatch = useDispatch();
	const customer = useSelector(({ vino }) => vino.checkout.customer);
	const checkout = useSelector(({ vino }) => vino.checkout);
	const user = useSelector(({ auth }) => auth.user);
	const paymentMethods = useSelector(selectPaymentMethods);

	const { isSubmitting } = checkout;

	const methods = useForm({
		mode: "onChange",
		defaultValues: paymentDefaultValues,
		resolver: yupResolver(PaymentSchema),
	});

	const { handleSubmit, setValue, watch } = methods;
	const addNewCard = watch("addNewCard");

	useEffect(() => {
		if (user.isUserLoaded) {
			dispatch(fetchPaymentMethods());
		}
	}, [dispatch]);

	useEffect(() => {
		setValue("addNewCard", paymentMethods.length === 0);
		setValue("selectPaymentMethod", paymentMethods.length > 0);
	}, [paymentMethods, setValue]);

	useEffect(() => {
		setValue("address", customer.address);
	}, [customer]);

	const handelChangeUseShippingAddress = (e) => {
		setUseShippingAddress(e.target.checked);
	};

	const handleCancelCardCreate = () => {
		setValue("addNewCard", false);
		setValue("selectPaymentMethod", true);
	};

	const onSubmit = (paymentMethod) => {
		const model = {
			checkout,
			paymentMethod,
		};
		dispatch(updatePaymentMethod({ model, navigate }));
	};

	return (
		<Paper className="w-full rounded-20 shadow">
			<FormProvider {...methods}>
				<form
					noValidate
					className="flex flex-col w-full"
					onSubmit={handleSubmit(onSubmit)}
				>
					<div className="flex items-center p-20 pb-0">
						<Typography className="text-16 font-medium">Payment</Typography>
					</div>

					<div className="w-full px-20">
						{!addNewCard && <PaymentList paymentList={paymentMethods} />}

						{addNewCard && (
							<div className="pt-20">
								<div className="flex justify-between">
									<Typography className="text-16">Credit Card</Typography>
									{paymentMethods.length > 0 && (
										<Button onClick={handleCancelCardCreate}>Cancel</Button>
									)}
								</div>
								<div className="mt-10">
									<PaymentMethodCard />
								</div>
							</div>
						)}
					</div>
					{addNewCard && <Divider className="my-10" />}
					<div className="w-full p-20">
						{addNewCard && (
							<BillingAddress
								useShippingAddress={useShippingAddress}
								onChangeUseShippingAddress={handelChangeUseShippingAddress}
							/>
						)}

						<div className="flex justify-between">
							<Button onClick={onBack}>Back</Button>
							<Button isSubmitting={isSubmitting} type="submit">
								Place Order
							</Button>
						</div>
					</div>
				</form>
			</FormProvider>
		</Paper>
	);
};

export default PaymentMethodOptions;
